import React, { useEffect, useState } from "react";

import { BranchPartnerDto } from "services/organizationBranches/restModels";
import { getPartners } from "services/partners/rest";
import { PartnerDto } from "services/partners/restModels";
import { Banner } from "shared/ui/Banner";
import { Button } from "shared/ui/Button";
import { EmptyState } from "shared/ui/EmptyState";
import { LabeledField } from "shared/ui/LabeledField";
import { Select } from "shared/ui/Select";
import { Skeleton } from "shared/ui/Skeleton";

import { Actions, Form } from "../../styles";

interface PartnerTabProps {
    partner: BranchPartnerDto | null;
    saving: boolean;
    onSave: (partnerId: number) => void;
    onRemove: () => void;
}

export const PartnerTab = ({ partner, saving, onSave, onRemove }: PartnerTabProps) => {
    const [partners, setPartners] = useState<PartnerDto[] | null>(null);
    const [loading, setLoading] = useState(true);
    const [partnerId, setPartnerId] = useState<number | null>(partner?.id ?? null);

    useEffect(() => {
        let ignore = false;

        getPartners().catch(() => null).then((response) => {
            if (ignore) return;

            setPartners(response);
            setLoading(false);
        });

        return () => {
            ignore = true;
        };
    }, []);

    useEffect(() => {
        setPartnerId(partner?.id ?? null);
    }, [partner]);

    if (loading) return <Skeleton height="160px" />;

    if (!partners) return <Banner tone="danger" title="Не удалось загрузить партнёров" />;

    if (partners.length === 0) {
        return (
            <EmptyState
                title="Партнёров пока нет"
                description="Заведите партнёра в разделе «Партнёры»"
            />
        );
    }

    return (
        <Form>
            <LabeledField label="Партнёр заведения">
                <Select
                    value={partnerId}
                    options={partners.map(({ id, name }) => ({ value: id, label: name }))}
                    placeholder="Не назначен"
                    title="Партнёр заведения"
                    onChange={(value) => setPartnerId(Number(value))}
                    disabled={saving}
                />
            </LabeledField>

            <Actions>
                {partner && (
                    <Button variant="outlined" color="danger" onClick={onRemove} disabled={saving}>
                        Снять партнёра
                    </Button>
                )}
                <Button
                    onClick={() => partnerId !== null && onSave(partnerId)}
                    disabled={saving || partnerId === null || partnerId === partner?.id}
                >
                    Сохранить
                </Button>
            </Actions>
        </Form>
    );
};
